import { ICreateRequestDto } from 'common/dto/RequestDto';
import { IProcedure } from 'common/schema/Procedure';
import * as React from 'react';
import { useCallback, useState } from 'react';
import { RequestCompileContext } from './RequestCompileContext';

export interface IRequestCompileContextProviderProps {
  procedure: IProcedure;
  request: ICreateRequestDto;
  children: React.ReactNode;
}

export function RequestCompileContextProvider(
  props: IRequestCompileContextProviderProps
) {
  const { procedure, request } = props;
  const [currentStep, setCurrentStep] = useState(0);

  return (
    <RequestCompileContext.Provider
      value={{ procedure, request, currentStep, setCurrentStep }}
    >
      {props.children}
    </RequestCompileContext.Provider>
  );
}
